import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import LoginPage from './pages/LoginPage';
import FirstLoginPage from './pages/FirstLoginPage';
import Dashboard from './pages/Dashboard';
import UserManagement from './pages/UserManagement';
import ProductManagement from './pages/ProductManagement';
import useAuth from './hooks/useAuth';
import SupplierManagement from './pages/SupplierManagement';
import PartnerManagement from './pages/PartnerManagement';
import DistributorManagement from './pages/DistributorManagement';
import RetailerManagement from './pages/RetailerManagement';
import InventoryManagement from './pages/InventoryManagement';
import OrderManagement from './pages/OrderManagement';
import ReportingPage from './pages/ReportingPage';
import ProfilePage from './pages/ProfilePage';
import InvoiceManagement from './pages/InvoiceManagement'
import DNManagement from './pages/DNManagement';
import MagasinManagement from './pages/MagasinManagement';
import ZoneManagement from './pages/ZoneManagement';


// Route protégée qui vérifie l'authentification
const ProtectedRoute = ({ children }) => {
    const { isAuthenticated, isFirstLogin } = useAuth();

    if (!isAuthenticated) {
        return <Navigate to="/login" />;
    }

    if (isFirstLogin) {
        return <Navigate to="/first-login" />;
    }

    return children;
};

// Route pour la première connexion
const FirstLoginRoute = ({ children }) => {
    const { isAuthenticated, isFirstLogin } = useAuth();

    if (!isAuthenticated) {
        return <Navigate to="/login" />;
    }

    if (!isFirstLogin) {
        return <Navigate to="/dashboard" />;
    }

    return children;
};

const AdminRoute = ({ children }) => {
    const { isAuthenticated, isFirstLogin, isAdmin, isManager } = useAuth();

    if (!isAuthenticated) {
        return <Navigate to="/login" />;
    }

    if (isFirstLogin) {
        return <Navigate to="/first-login" />;
    }

    if (!isAdmin && !isManager) {
        return <Navigate to="/dashboard" />;
    }

    return children;
};

const AppRoutes = () => {
    return (
        <Routes>
            <Route path="/login" element={<LoginPage />} />
            <Route
                path="/first-login"
                element={
                    <FirstLoginRoute>
                        <FirstLoginPage />
                    </FirstLoginRoute>
                }
            />
            <Route
                path="/users"
                element={
                    <ProtectedRoute>
                        <UserManagement />
                    </ProtectedRoute>
                }
            />
            <Route
                path="/dashboard"
                element={
                    <ProtectedRoute>
                        <Dashboard />
                    </ProtectedRoute>
                }
            />

            <Route 
            path="/buildings" 
            element={
                <ProtectedRoute>
                    <MagasinManagement  />
                </ProtectedRoute>
                } />

            <Route 
            path="/zones" 
            element={
                <ProtectedRoute>
                    <ZoneManagement />
                </ProtectedRoute>
                } />
            
            {/* Correction: une seule barre oblique */}
            <Route
                path="/delivery-notes"
                element={
                    <ProtectedRoute>
                        <DNManagement />
                    </ProtectedRoute>
                }
            />

            <Route
                path="/products"
                element={
                    <ProtectedRoute>
                        <ProductManagement />
                    </ProtectedRoute>
                }
            />

            <Route
                path="/inventory"
                element={
                    <ProtectedRoute>
                        <InventoryManagement />
                    </ProtectedRoute>
                }
            />

            <Route
                path="/orders"
                element={
                    <ProtectedRoute>
                        <OrderManagement />
                    </ProtectedRoute>
                }
            />

            <Route
                path="/invoices"
                element={
                    <ProtectedRoute>
                        <InvoiceManagement />
                    </ProtectedRoute>
                }
            />

            <Route
                path="/reports"
                element={
                    <AdminRoute>
                        <ReportingPage />
                    </AdminRoute>
                }
            />
            
            <Route
                path="/profile"
                element={
                    <ProtectedRoute>
                        <ProfilePage />
                    </ProtectedRoute>
                }
            />

            {/* Page principale des partenaires */}
            <Route
                path="/partners"
                element={
                    <ProtectedRoute>
                        <PartnerManagement />
                    </ProtectedRoute>
                }
            />

            {/* Routes pour les sous-sections des partenaires */}
            {/* <Route
                path="/suppliers/*"
                element={
                    <ProtectedRoute>
                        <SupplierManagement />
                    </ProtectedRoute>
                }
            /> */}

            <Route
                path="/distributors/*"
                element={
                    <ProtectedRoute>
                        <DistributorManagement />
                    </ProtectedRoute>
                }
            />

            <Route
                path="/retailers/*"
                element={
                    <ProtectedRoute>
                        <RetailerManagement />
                    </ProtectedRoute>
                }
            />
            
            <Route path="/" element={<Navigate to="/dashboard" />} />
            <Route path="*" element={<Navigate to="/dashboard" />} />
        </Routes>
    );
};

export default AppRoutes;